import React from 'react';
import './TodosEmpty.css';

export function TodosEmpty() {
  return (
    <li className='TodosEmpty'>
      No To-Dos Found!
      <small>Maybe add one above? ☝️</small>
      <span className='Emoji'>🤷‍♂️</span>
    </li>
  )
}